import React, { useState, useEffect } from "react";
import styles from "./EMIRepayment.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import EMIsAPI from "../../services/emi-api";
import moment from "moment";
import FetchingRepayment from "./FetchingRepayment/FetchingRepayment";

export default function EMIRepayment() {
  const [data, setData] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAPI = async () => {
      const { repaymentDataAPI } = new EMIsAPI();
      const res = await repaymentDataAPI();
      if (res.success) {
        setData(res.data);
      }
    };

    fetchAPI();
  }, []);

  const overdueStatus = data && data?.getEmis.find((item) => item.status === "Overdue");

  if (!data) {
    return null;
  }
  return (
    <>
      {data.getEmis.length > 0 ? (
        <div className={styles.emiRepayment}>
          {/* Cash */}
          <div className={styles.cash}>
            <div>
              <h3>
                Cash Loan <span>₹{data.loanSummary.principal}</span>
              </h3>
              <p>
                Final Date <span>{moment(data?.getEmis.at(-1)?.dueDate).format("MMM D, YYYY")}</span>
              </p>
            </div>
            <div>
              <Link to="/loan-details">
                <MdKeyboardArrowRight size={30} color="#b7b1b1" />
              </Link>
            </div>
          </div>

          {/* EMIs List */}
          <div className={styles.emis}>
            {data?.getEmis
              ?.filter((item) => item.status !== "Paid")
              .slice(0, 3)
              .map((item, index) => (
                <React.Fragment key={index}>
                  <div className={`${styles.emiList} ${item.status === "Overdue" ? styles.emiListOverdue : ""}`}>
                    <div className={styles.emiAmount}>
                      <div className={styles.number}>1</div>
                      <div>
                        <p className={styles.amount}>₹{item.amountPayable}</p>
                        <p className={styles.date}>on {moment(item.dueDate).format("Do MMM, YYYY")}</p>

                        {item.status === "Overdue" && (
                          <div className={styles.overdueDay}>
                            {moment().diff(moment(item.dueDate), "days")} days Overdue
                          </div>
                        )}
                      </div>
                    </div>

                    {index === 0 && (
                      <button
                        className={styles.repay}
                        onClick={() => {
                          navigate("/re-payment")
                        }}
                      >
                        Repay
                      </button>
                    )}
                  </div>
                </React.Fragment>
              ))}
          </div>

          {/* Buttons */}
          <div className={styles.button}>
            <button className={styles.btn} onClick={() => navigate("/loan-details")}>
              View All
            </button>
            <button
              className={`${styles.btn} ${styles.btnActive}`}
              onClick={() => {
                navigate("/re-payment")
              }}
            >
              Repay All
            </button>
          </div>
        </div>
      ) : (
        <FetchingRepayment />
      )}

      {overdueStatus && <div className={styles.delayRepayment}>Delays in repayment may affect your CIBIL score</div>}
    </>
  );
}
